module.exports = __webpack_public_path__ + "static/img/hk.d3ad36de.png";